import { Component, OnInit, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { Utils } from 'src/app/shared/utils';


@Component({
  selector: 'app-midlandtravel',
  templateUrl: './midlandtravel.component.html',
  styleUrls: ['./midlandtravel.component.scss']
})
export class MidlandtravelComponent implements OnInit {

  @Output() public headerHeight: EventEmitter<any> = new EventEmitter();
  @ViewChild('header') headerRef!: ElementRef;
  @Output() public headerHeight1: EventEmitter<any> = new EventEmitter();
  @ViewChild('header1') headerRef1!: ElementRef;


  constructor(
    public companyParamsService: CompanyParamsService
  ) { }
  showMenu: boolean = false;

  ngOnInit(): void {
  }

  renderMenu() {
    this.showMenu = !this.showMenu;
  }

  goFavorites() {
    const urlFavorites: any =
      this.companyParamsService.getNameUrl() +
      '/wishlist';
    Utils.openNewTab(urlFavorites);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      var height = this.headerRef.nativeElement.offsetHeight;
      this.headerHeight.emit(height);
      var height1 = this.headerRef1.nativeElement.offsetHeight;
      this.headerHeight1.emit(height1);
    }, 300);
  }
}
